import { Vector3, Shape } from 'three';

const cloneAndMove = (loop: Vector3[], x: number, y: number) => {
    return move(loop.map(v => v.clone()), x,y);
};

const move = (loop: Vector3[], x: number, y: number) => {
    const offset = new Vector3(x, y, 0);
    const scalar = offset.length();
    offset.normalize();
    loop.forEach(v => v.addScaledVector(offset, scalar));
    return loop;
};

const getArcPoints = ( radius: number, startAngle: number, endAngle: number, segments: number) => {
    const points : Vector3[] = [];
    for (let i = 0; i <= segments; i++) {
        const angle = startAngle + (endAngle - startAngle) * i / segments;
        points.push(new Vector3(radius * Math.cos(angle), radius * Math.sin(angle), 0));
    }
    return points;
};

export { cloneAndMove, move, getArcPoints };